import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  Branch,
  CreateBranchReq,
  UpdateBranchReq,
} from "./branch-settings.interface";

@Injectable({
  providedIn: "root",
})
export class BranchSettingsService {
  constructor(private httpClient: HttpClient) {}

  public fetchBranches(): Observable<Branch[]> {
    return this.httpClient.get<Branch[]>(`/api/branches`);
  }

  public fetchCurrentBranch(): Observable<Branch> {
    return this.httpClient.get<Branch>(`/api/branches/current`);
  }

  public addBranch(form: CreateBranchReq): Observable<Branch> {
    return this.httpClient.post<Branch>(`/api/branches`, form);
  }

  public removeBranch(branchId: string): Observable<unknown> {
    return this.httpClient.delete(`/api/branches/${branchId}`);
  }

  public updateBranch(
    branchId: string,
    form: UpdateBranchReq,
  ): Observable<Branch> {
    return this.httpClient.put<Branch>(`/api/branches/${branchId}`, form);
  }
}
